import React, { useState, useEffect, useRef } from "react";
import blogFetch from "../../axios/config";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Send, AttachFile } from "@mui/icons-material";
import { IconButton, Paper } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { getIdCompany } from "../../utils/constantes";
import Select from "@mui/material/Select";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props, ref) => {
  const [workInstructive, setWorkInstructive] = useState(props.workInstructive);
  const [startShowing, setStartShowing] = useState();
  const [stopShowing, setStopShowing] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [sectors, setSectors] = useState({});
  const [sectorSelected, setSectorSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [name, setName] = useState(null);
  const [code, setCode] = useState(null);
  const [theme, setTheme] = useState(null);
  const [description, setDescription] = useState(null);
  const [pageChanged, setPageChanged] = useState(null);
  const [userName, setUserName] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getWorkInstructive();
    getSector();
  }, []);

  useImperativeHandle(ref, () => ({
    addInstructive,
    updateInstructive,
  }));

  const handleChangeSector = (event) => {
    setSectorSelected(event.target.value);
  };

  const getSector = async () => {
    try {
      let response = await blogFetch.get(`/sector?companyId=${getIdCompany()}`);
      let data = response.data;
      setSectors(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getWorkInstructive = async () => {
    if (props.workInstructiveId != null) {
      setIsLoading(true);
      try {
        let response = await blogFetch.get(
          `/WorkInstructive/${props.workInstructiveId}`
        );
        let data = response.data;
        setTimeout(() => {
          setDescription(data.wrK_description);
          setCode(data.wrK_code);
          setPageChanged(data.wrK_pageChanged);
          setTheme(data.wrK_theme);
          setUserName(data.wrK_userName);
          setName(data.wrK_name);
          setSectorSelected(data.sector);
          setIsLoading(false);
        }, 300);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const addInstructive = async () => {
    setIsSaveClicked(true);
    try {
      if (!name || !code) {
        return;
      }
      setLoading(true);

      let data = {
        WRK_name: name,
        WRK_code: code,
        WRK_theme: theme,
        WRK_description: description,
        WRK_pageChanged: pageChanged,
        WRK_userName: userName,
        WRK_startShowing: startShowing,
        WRK_stopShowing: stopShowing,
        WRK_Fk_sectorId: sectorSelected.stR_PK_idSector,
        WRK_FK_companyId: getIdCompany(),
      };

      let response = await blogFetch.post("/WorkInstructive", data);
      let ret = response.data;

      let formData = new FormData();

      formData.append("entryFile", selectedFile);
      if (selectedFile) {
        await blogFetch.post(`/Documents/${code}`, formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            if (percentCompleted > 95) {
              setUploadProgress(99);
            } else {
              setUploadProgress(percentCompleted);
            }
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      setIsSaveClicked(false);
      setLoading(false);
    } catch (error) {
      if (error.request.status) {
        alert("Código duplicado");
      }
      setLoading(false);
    }
  };
  const updateInstructive = async () => {
    setIsSaveClicked(true);
    try {
      if (!name || !code) {
        return;
      }
      setLoading(true);

      let data = {
        WRK_name: name,
        WRK_code: code,
        WRK_theme: theme,
        WRK_description: description,
        WRK_pageChanged: pageChanged,
        WRK_userName: userName,
        WRK_startShowing: startShowing,
        WRK_stopShowing: stopShowing,
        WRK_Fk_sectorId: sectorSelected.stR_PK_idSector,
        WRK_FK_companyId: getIdCompany(),
      };

      let response = await blogFetch.put(
        `/WorkInstructive/${props.workInstructiveId}`,
        data
      );
      let ret = response.data;

      let formData = new FormData();

      formData.append("entryFile", selectedFile);
      if (selectedFile) {
        await blogFetch.post(`/Documents/${code}`, formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            if (percentCompleted > 95) {
              setUploadProgress(99);
            } else {
              setUploadProgress(percentCompleted);
            }
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      setIsSaveClicked(false);
      setLoading(false);
    } catch (error) {
      console.log(error);

      setLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      ) : (
        <div style={{ flexDirection: "column", gap: 10 }}>
          <center>
            <Send fontSize="large" className="pr-1" />
            <span>Novo Instrutivo</span>
          </center>
          <FormControl
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <TextField
              value={name}
              required
              error={isSaveClicked && !name}
              size="small"
              id="outlined-basic"
              label="Nome do Documento"
              variant="outlined"
              fullWidth
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              value={code}
              required
              error={isSaveClicked && !code}
              size="small"
              id="outlined-basic"
              variant="outlined"
              fullWidth
              label="Código do instrutivo"
              onChange={(e) => setCode(e.target.value)}
            />
            <TextField
              value={theme}
              size="small"
              id="outlined-basic"
              fullWidth
              label="Assunto"
              variant="outlined"
              onChange={(e) => setTheme(e.target.value)}
            />
            <TextField
              value={description}
              size="small"
              id="outlined-basic"
              fullWidth
              label="Descrição das alterações"
              variant="outlined"
              multiline
              maxRows={4}
              minRows={2}
              onChange={(e) => setDescription(e.target.value)}
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Setor</InputLabel>
              <Select
                required
                error={isSaveClicked && !sectorSelected}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Setor"
                value={sectorSelected}
                onChange={handleChangeSector}
              >
                {!!sectors &&
                  Object.entries(sectors).map((item) => (
                    <MenuItem value={item[1]}>
                      {item[1].stR_description}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Inicio da Exibição"
                fullWidth
                format="DD/MM/YYYY"
                className="date-piker"
                onChange={setStartShowing}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Fim da Exibição"
                fullWidth
                format="DD/MM/YYYY"
                className="date-piker"
                onChange={setStopShowing}
              />
            </LocalizationProvider>
            <Paper elevation={0} square>
              <IconButton component="label">
                <AttachFile />
                <Typography variant="body2">Inserir arquivo</Typography>
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    setSelectedFile(e.target.files[0]);
                  }}
                />
              </IconButton>
              {selectedFile && (
                <Typography variant="subtitle2" sx={{ marginLeft: 2 }}>
                  {selectedFile.name}
                </Typography>
              )}
            </Paper>
            <TextField
              value={pageChanged}
              size="small"
              id="outlined-basic"
              fullWidth
              label="Número da página de alteração"
              variant="outlined"
              onChange={(e) => setPageChanged(e.target.value)}
            />
            <TextField
              value={userName}
              size="small"
              id="outlined-basic"
              fullWidth
              label="Nome do usuário"
              variant="outlined"
              onChange={(e) => setUserName(e.target.value)}
            />

            <div className="d-flex" style={{ justifyContent: "end" }}>
              <div
                style={{
                  marginRight: "40vh",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  value={uploadProgress}
                  sx={loading ? {} : { display: "none" }}
                />
                <p
                  style={loading ? { paddingTop: "12px" } : { display: "none" }}
                >
                  {`${Math.round(uploadProgress)}%`}
                </p>
              </div>
            </div>
          </FormControl>
        </div>
      )}
    </>
  );
});
